import { MapTo } from '@adobe/aem-react-editable-components';
import { withAuthorPanelSwitch } from '@adobe/aem-core-components-react-spa';
import { WithEmptyPlaceholder } from '../../../../lib/hoc/WithEmptyPlaceholder';
import Tabs from './Tabs';
import withAttributes from '../../../../lib/hoc/withAttributes';
import { TabsProps } from './Tabs.types';

const RESOURCE_TYPE = 'learning-academy/components/custom/tabs';

const TabsEmptyFn = (props: TabsProps) => !props;

const EditConfig = {
  emptyLabel: 'Tabs',
  isEmpty: TabsEmptyFn,
};

export default MapTo<Omit<TabsProps, 'extraAttributes'>>(RESOURCE_TYPE)(
  ...WithEmptyPlaceholder(withAttributes(withAuthorPanelSwitch(Tabs), 'tabs'), EditConfig),
);
